import { render } from "./AlarmModal.vue?vue&type=template&id=4c8af1ff"
import script from "./AlarmModal.vue?vue&type=script&lang=js"
export * from "./AlarmModal.vue?vue&type=script&lang=js"

import "./AlarmModal.vue?vue&type=style&index=0&id=4c8af1ff&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__